<template>
  <div v-loading="loading" class="new-question-show flex-1 overflow-auto">
    <render-container-group>
      <render-container v-for="qs of questionList" :key="qs.q_id">
        <question-item :question="qs" :enableQuestionIndex="enableQuestionIndex" />
        <div v-if="qs.confirmText || (qs.confirmFiles && qs.confirmFiles.length)" class="confirm-info">
          <div class="confirm-info__header">
            <span>答案变更佐证</span>
            <el-button type="text" size="mini" @click="openConfirmDialog(qs)">编辑</el-button>
          </div>
          <div v-if="qs.confirmText" class="confirm-info__text">{{ qs.confirmText }}</div>
          <div v-if="qs.confirmFiles && qs.confirmFiles.length" class="confirm-info__files">
            <a
              v-for="(file, idx) in qs.confirmFiles"
              :key="idx"
              :href="convertDownloadUrl(file.url)"
              target="_blank"
              class="confirm-info__file"
            >{{ file.name }}</a>
          </div>
        </div>
      </render-container>
    </render-container-group>

    <el-dialog
      title="答案变更佐证"
      :visible.sync="confirmDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form label-position="top">
        <el-form-item label="佐证内容">
          <el-input
            v-model="confirmText"
            type="textarea"
            :rows="4"
            placeholder="请填写佐证内容"
          />
        </el-form-item>
        <el-form-item label="佐证文件">
          <el-upload
            action="/fill/api/v1/upload"
            :with-credentials="true"
            :file-list="confirmFiles"
            :on-success="handleConfirmUploadSuccess"
            :on-remove="handleConfirmUploadRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleConfirmCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirmOk">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pc from 'pc'
import { createQuestionFactory } from '@dygc/question'
import { detail } from '@/api/wenjuan/answerList'
const QuestionItem = pc.QuestionItem
import { convertAnswerText } from '@/question/convert.js'
import { getQuestionNo, getColsestDif, isPreNo } from '@/components/survey-detail/detailMeans'
import { questionType } from '@dygc/question'
import cloneDeep from 'lodash/cloneDeep'
import RenderContainerGroup from '@/components/base/RenderContainerGroup.vue'
import RenderContainer from '@/components/base/RenderContainer.vue'
import { convertDownloadUrl } from '@/api/file'

export default {
  name: 'NewQuestionEdit',
  components: {
    RenderContainer,
    RenderContainerGroup,
    QuestionItem
  },
  props: {
    answerId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      feikaiArr: [],
      questionList: [],
      loading: false,
      editAnswer: [],
      confirmDialogVisible: false,
      confirmText: '',
      confirmFiles: [],
      confirmQuestionId: null
    }
  },
  computed: {
    //矩阵题
    matrixTypes() {
      return [
        questionType.MATRIX_SINGLE_CHOICE,
        questionType.MATRIX_MULTIPLE_CHOICE,
        questionType.MATRIX_SELECT_CHOICE,
        questionType.MATRIX_FILL,
        questionType.CUSTOM_MULTIPLE_SCALE,
        questionType.MATRIX_SCALE,
        questionType.MULTIPLE_BLANKS
      ]
    },
    enableQuestionIndex(){
      return this.$store.getters.otherSetting?.enableQuestionIndex !== false
    }
  },
  watch: {
    answerId(n) {
      if (n) this.getDetail(n)
    }
  },
  methods: {
    getQuestionNo,
    getColsestDif,
    isPreNo,
    convertDownloadUrl,
    handleConfirmOk() {
      const q = this.questionList.find(q => q.id === this.confirmQuestionId)
      if (q) {
        q.confirmText = this.confirmText
        q.confirmFiles = [...this.confirmFiles]
      }
      this.confirmDialogVisible = false
    },
    handleConfirmCancel() {
      this.confirmDialogVisible = false
    },
    openConfirmDialog(q) {
      this.confirmQuestionId = q.id
      this.confirmText = q.confirmText || ''
      this.confirmFiles = q.confirmFiles || []
      this.confirmDialogVisible = true
    },
    handleConfirmUploadSuccess(res, file, fileList) {
      console.log(fileList)
      this.confirmFiles = fileList.map(f => ({
        name: f.name,
        url: f.response?.data?.url || f.url
      }))
    },
    handleConfirmUploadRemove(file, fileList) {
      this.confirmFiles = fileList.map(f => ({
        name: f.name,
        url: f.response?.data?.url || f.url
      }))
    },
    getDetail(aswId) {
      this.loading = true
      detail(aswId).then(res => {
        const d = res.data.data
        this.feikaiArr = d.answerContent
        this.feikaiArr.length && this.getQuestionNo()
        this.questionList = this.feikaiArr.filter(item=>item.questionDetails).map((item) => {
          item.questionDetails = {
            ...item.questionDetails,
            content: {
              ...item.questionDetails.content,
              text: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent),
              richText: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent)
            }
          }
          let q = createQuestionFactory(cloneDeep(item.questionDetails))
          // 审核编辑使用独立的题目副本，日期题不受作答时的日期范围限制
          if ([questionType.DATE, questionType.DATE_OF_BIRTH].includes(q.questionType)) {
            q.issue.min = ''
            q.issue.max = ''
            q.issue.validateType = 'time'
          }
          q.confirmText = item.confirmText
          q.confirmFiles = item.confirmFiles
          q.setValue(item)
          q.changeAnswerShowWarning = this.$store.getters.otherSetting?.changeAnswerShowWarning === true && [questionType.SINGLE_CHOICE,questionType.MULTIPLE_CHOICE].includes(q.questionType)
          q.oldValue = item.oldItems?{...item,items:item.oldItems}:item
          q.disabledProgress = true
          q.num = item.questionNo
          if(this.matrixTypes.includes(q.questionType) && q.required) {
            q.setting.requiredType = 1
          }
          q.setHook('updated', ()=>{
            console.log(q)
            const ids = this.editAnswer.map(item => item.id)
            const index = ids.indexOf(q.id)
            if(index >-1) {
              this.editAnswer.splice(index, 1, q)
            }else {
              this.editAnswer.push(q)
            }
            if (q.changeAnswerShowWarning) {
              if (q.issue.hasAnswerChanged(q.issue.select,item?.items?.map?.(item=>item.optionId))) {
                this.confirmQuestionId = q.id
                this.confirmText = q.confirmText || ''
                this.confirmFiles = q.confirmFiles || []
                this.confirmDialogVisible = false
                this.$nextTick(() => {
                  this.confirmDialogVisible = true
                })
              }
            }
          })
          return q
        })
        this.loading = false
      })
    },
    async getEditAnswer() {
      return await this.getAnswerContent(this.editAnswer)
    },
    async getAnswer() {
      return await this.getAnswerContent(this.questionList)
    },
    getAnswerContent(list) {
      let promises = []
      let answerList = []
      let error = null
      let errorQuestion
      for (let i = 0, len = list.length; i < len; i++) {
        let q = list[i]
        let content = q.getAnswerContent('submit')
        if (q.confirmText) content.confirmText = q.confirmText
        if (q.confirmFiles?.length) content.confirmFiles = q.confirmFiles
        if (content.items instanceof Promise) {
          promises.push(
            content.items.then((res) => {
              content.items = [res]
            })
          )
        }
        answerList.push(content)
        // let flag = q.checkAnswer(content, {})
        // if (!flag.success) {
        //   error = flag
        //   errorQuestion = q
        //   break
        // } else {
          q.runHooks('submitSuccess')
        // }
      }

      if (error) {
        return Promise.reject(error)
      } else {
        if (promises.length) {
          return Promise.all(promises).then(() => {
            return answerList
          })
        } else {
          return Promise.resolve(answerList)
        }
      }
    }
  },
  created() {
    this.getDetail(this.answerId)
  }
}
</script>

<style>
.confirm-info {
  margin: 8px 16px 0;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}
.confirm-info__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  margin-bottom: 6px;
  color: #303133;
}
.confirm-info__text {
  white-space: pre-wrap;
  line-height: 1.5;
}
.confirm-info__files {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.confirm-info__file {
  color: #409eff;
  text-decoration: none;
}
.confirm-info__file:hover {
  text-decoration: underline;
}
</style>